import { render, staticRenderFns } from "./FriendCardDBL.vue?vue&type=template&id=04bc0e04&scoped=true&"
import script from "./FriendCardDBL.vue?vue&type=script&lang=js&"
export * from "./FriendCardDBL.vue?vue&type=script&lang=js&"
import style0 from "./FriendCardDBL.vue?vue&type=style&index=0&id=04bc0e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc0e04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bc0e04')) {
      api.createRecord('04bc0e04', component.options)
    } else {
      api.reload('04bc0e04', component.options)
    }
    module.hot.accept("./FriendCardDBL.vue?vue&type=template&id=04bc0e04&scoped=true&", function () {
      api.rerender('04bc0e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/雙人合盤/FriendCardDBL.vue"
export default component.exports